import { render, staticRenderFns } from "./UserPermissionList.vue?vue&type=template&id=31eca60a"
import script from "./UserPermissionList.vue?vue&type=script&lang=js"
export * from "./UserPermissionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports